import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';
import { analyticsCtaDataObject } from '../../../helpers/adobe-analytics';

export class River extends Lit3formBlock {
  static get characterName() {
    return 'river';
  }

  static get characterProperties() {
    return {
      headerText: { type: String },
      descriptionText: { type: String },
      imagesArr: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid river-layout">
          <div class="block-header">
            <h2>${unsafeHTML(this.withLineBreaks(this.headerStr))}</h2>
            <cta-text
              class="mobile-only"
              cta-data=${this.ctaData()}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaData(),
                this.headerStr
              )}
            ></cta-text>
          </div>
          <div class="description">
            <p>${unsafeHTML(this.withLineBreaks(this.descriptionStr))}</p>
            <cta-text
              class="not-mobile"
              cta-data=${this.ctaData()}
              .ctaAnalyticsData=${analyticsCtaDataObject(
                this.ctaData(),
                this.headerStr
              )}
            ></cta-text>
          </div>
          <div class="images">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    return html`
      <div class="image-wrapper">
        <img src=${this.imageUrl(image)} />
        <div class="image-info">
          <h3 class="bold">${unsafeHTML(this.withLineBreaks(image.header))}</h3>
          <p class="font-size-small">
            ${unsafeHTML(this.withLineBreaks(this.imageDescription(image)))}
          </p>
          <cta-text
            cta-data=${this.ctaData(image)}
            .ctaAnalyticsData=${analyticsCtaDataObject(image, this.headerStr)}
          ></cta-text>
        </div>
      </div>
    `;
  }

  imageUrl(img) {
    return this.imagebossUrl(img.src, 320, null);
  }

  imageDescription(img) {
    return img.description || '';
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionStr() {
    return this.withLineBreaks(this.content.description) || '';
  }

  ctaData(image) {
    let cta;
    if (image) {
      cta = image.cta;
      cta.notBold = true;
    } else {
      cta = this.content.cta;
    }
    return JSON.stringify(cta);
  }

  get imagesArr() {
    if (!this.content.images || this.content.images.length === 0) {
      return [];
    }
    return this.content.images;
  }
}
River.defineElement();
